"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var DeveloperComponent_module_css_1 = __importDefault(require("./DeveloperComponent.module.css"));
var AppEditorList_1 = __importDefault(require("./AppEditor/AppEditorList"));
var AppTemplateEditorList_1 = __importDefault(require("./AppTemplateEditor/AppTemplateEditorList"));
var NewAppTemplateModal_1 = __importDefault(require("./AppTemplateEditor/NewAppTemplateModal"));
var NewAppModal_1 = __importDefault(require("./AppEditor/NewAppModal"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_admin_1 = require("react-admin");
var AjaxProvider_1 = __importDefault(require("../../functions/AjaxProvider"));
var AjaxProvider_2 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var IntegrationTemplateList_1 = __importDefault(require("./IntegrationEditor/IntegrationTemplateList"));
var DeveloperComponent = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(localStorage.getItem("devActiveTab") || "Integration Editor"), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)(false), isNewAppTemplateModalShown = _b[0], setIsNewAppTemplateModalShown = _b[1];
    var _c = (0, react_1.useState)({}), appVersions = _c[0], setAppVersions = _c[1];
    var _d = (0, react_1.useState)({}), appTemplateVersions = _d[0], setAppTemplateVersions = _d[1];
    var logger = q_play_core_1.logManager.getLogger();
    var fetchAppVersions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var appVersionsData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, AjaxProvider_2.default)("/api").getLatestVersions("app-editor/version")];
                case 1:
                    appVersionsData = _a.sent();
                    setAppVersions(appVersionsData);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error fetching app versions:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchAppTemplateVersions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var appTemplateVersionsData, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, AjaxProvider_2.default)("/api").getLatestVersions("app-template-editor/version")];
                case 1:
                    appTemplateVersionsData = _a.sent();
                    setAppTemplateVersions(appTemplateVersionsData);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error fetching app template versions:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var hash;
        switch (active) {
            case "Integration Editor":
                hash = "#/integration_editor";
                break;
            case "App Editor":
                hash = "#/app_editor";
                break;
            case "Template Editor":
                hash = "#/template_editor";
                break;
            default:
                hash = "";
        }
        window.location.hash = hash;
        localStorage.setItem("devActiveTab", active);
    }, [active]);
    var toggleNewAppTemplateModal = function () {
        setIsNewAppTemplateModalShown(!isNewAppTemplateModalShown);
    };
    var getCreateButtonText = function () {
        switch (active) {
            case "Integration Editor":
                return t("Create New Integration");
            case "App Editor":
                return t("Create New App");
            case "Template Editor":
                return t("Create New Template");
            default:
                return "Create";
        }
    };
    return (react_1.default.createElement(react_admin_1.AdminContext, { dataProvider: (0, AjaxProvider_1.default)("/api") },
        react_1.default.createElement(react_admin_1.I18nContextProvider, { value: react_admin_1.defaultI18nProvider },
            react_1.default.createElement("div", { className: DeveloperComponent_module_css_1.default["content-container"] },
                react_1.default.createElement("div", { className: DeveloperComponent_module_css_1.default["tabs-and-button"] },
                    react_1.default.createElement("div", { className: DeveloperComponent_module_css_1.default.tabs },
                        react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Integration Editor"); }, text: t("Integration Editor"), active: active === "Integration Editor" }),
                        react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("App Editor"); }, text: t("App Editor"), active: active === "App Editor", "data-cy": "appEditorTab" }),
                        react_1.default.createElement(Tab_1.default, { onClick: function () { return setActive("Template Editor"); }, text: t("Template Editor"), active: active === "Template Editor", "data-cy": "templateEditorTab" })),
                    react_1.default.createElement(q_play_components_1.Button, { text: getCreateButtonText(), onClick: toggleNewAppTemplateModal, style: { alignSelf: "flex-end" } })),
                active === "Integration Editor" && (react_1.default.createElement(IntegrationTemplateList_1.default, { key: "integration-template-list" })),
                active === "App Editor" && (react_1.default.createElement("div", null,
                    react_1.default.createElement(AppEditorList_1.default, { key: "app-editor", versions: appVersions, fetchVersions: fetchAppVersions }),
                    react_1.default.createElement(NewAppModal_1.default, { isShown: isNewAppTemplateModalShown, toggle: toggleNewAppTemplateModal, fetchVersions: fetchAppVersions }))),
                active === "Template Editor" && (react_1.default.createElement("div", null,
                    react_1.default.createElement(AppTemplateEditorList_1.default, { key: "template-editor", fetchVersions: fetchAppTemplateVersions, versions: appTemplateVersions }),
                    react_1.default.createElement(NewAppTemplateModal_1.default, { isShown: isNewAppTemplateModalShown, toggle: toggleNewAppTemplateModal, fetchVersions: fetchAppTemplateVersions })))))));
};
exports.default = DeveloperComponent;
